import React from 'react';
import SyntaxHighlighter from 'react-syntax-highlighter/dist/esm/light';
import vs2015 from 'react-syntax-highlighter/dist/esm/styles/hljs/vs2015';

// Fonction utilitaire pour nettoyer et valider du JSON
const cleanJsonString = (jsonStr) => {
  if (!jsonStr || typeof jsonStr !== 'string') return jsonStr;
  
  // Nettoyer les caractères de retour à la ligne problématiques
  let cleaned = jsonStr
    .replace(/\r\n/g, '\n')
    .replace(/\r/g, '\n')
    .trim();
  
  // Vérifier si le JSON semble complet (commence par { ou [ et se termine par } ou ])
  const looksLikeJson = (cleaned.startsWith('{') && cleaned.endsWith('}')) ||
                        (cleaned.startsWith('[') && cleaned.endsWith(']'));
  
  if (!looksLikeJson) {
    // Pas du JSON, retourner nettoyé
    return cleaned
      .split('\n')
      .map(line => line.trimEnd())
      .join('\n');
  }
  
  // Tentative de parsing - plus simple maintenant car on a le contenu final complet
  try {
    const parsed = JSON.parse(cleaned);
    // Si le parsing réussit, reformater proprement
    return JSON.stringify(parsed, null, 2);
  } catch (e) {
    // En cas d'erreur, retourner le contenu nettoyé sans reformatage
    return cleaned
      .split('\n')
      .map(line => line.trimEnd())
      .join('\n');
  }
};

const MarkdownComponents = {
  code({node, inline, className, children, ...props}) {
    const match = /language-(\w+)/.exec(className || '');
    // Si le bloc est du JSON, tente de le parser et de le reformatter
    if (!inline && match && match[1] === 'json') {
      const originalJson = String(children);
      const cleanedJson = cleanJsonString(originalJson);
      
      return (
        <SyntaxHighlighter
          style={vs2015}
          language="json"
          PreTag="div"
          {...props}
          customStyle={{
            background: '#101010',
            color: '#fff',
            borderRadius: 12,
            border: '2px solid #252525',
            padding: 18,
            fontSize: 15,
            fontFamily: 'Fira Mono, Menlo, Monaco, Consolas, monospace',
            whiteSpace: 'pre-wrap',
            wordBreak: 'break-word',
            overflowWrap: 'break-word'
          }}
        >
          {cleanedJson}
        </SyntaxHighlighter>
      );
    }
    return !inline && match ? (
      <SyntaxHighlighter
        style={vs2015}
        language={match[1]}
        PreTag="div"
        {...props}
        customStyle={{
          background: '#101010',
          color: '#fff',
          borderRadius: 12,
          border: '2px solid #252525',
          padding: 18,
          fontSize: 15,
          fontFamily: 'Fira Mono, Menlo, Monaco, Consolas, monospace',
          whiteSpace: 'pre-wrap',
          wordBreak: 'break-word'
        }}
      >
        {String(children).replace(/\n$/, '').replace(/\r\n/g, '\n').replace(/\r/g, '\n')}
      </SyntaxHighlighter>
    ) : (
      <code className={className} {...props} style={{background:'#222',color:'#fff',padding:'2px 6px',borderRadius:4,fontFamily:'Fira Mono, Menlo, Monaco, Consolas, monospace'}}>
        {children}
      </code>
    );
  },
  table({children}) {
    return <table style={{borderCollapse:'collapse',width:'100%',margin:'12px 0',background:'#18191c',color:'#fff'}}>{children}</table>;
  },
  th({children}) {
    return <th style={{border:'1px solid #333',padding:'8px',background:'#222',fontWeight:'bold'}}>{children}</th>;
  },
  td({children}) {
    return <td style={{border:'1px solid #333',padding:'8px'}}>{children}</td>;
  },
};

export default MarkdownComponents;
